/***************************************************************
8/10/2017
Alexander Self
EmployeeInfoCard: Information about an employee in a card

***************************************************************/
import React from 'react';


const EmployeeInfoCard = ({ employee }) => {
  return (
    <div>
      <div className="card z-depth-4">
        <div className="row">
          <div className="col s12 m12 l12">
            <ul className="collection">
              <li className="collection-item">
                Location: <span className="right-align">
                <b>{
                    employee.location === '60' ? `${employee.location} - California`
                  : employee.location === '70' ? `${employee.location} - Admin`
                  : employee.location === '71' ? `${employee.location} - Ka'u`
                  : employee.location === '72' ? `${employee.location} - Kea'au`
                  : employee.location === '92' ? `${employee.location} - Hilo`
                  : ''
                }</b>
                </span>
              </li>
              <li className="collection-item">
                Type: <span className="right-align"><b>{ employee.type }</b></span>
              </li>
              <li className="collection-item">
                Position Type: <span className="right-align"><b>{ employee.positionType } { employee.partTime ? '- Part-time' : '' }</b></span>
              </li>
              <li className="collection-item">
                Status: <span className="center-align">
                  <b>
                    { employee.employeeStatus === 'Active' ? <span className="employee-active right-align">{employee.employeeStatus}</span>
                      : <span className="employee-inactive right-align">{employee.employeeStatus}</span>
                    }
                  </b>
                </span>
              </li>
              { employee.grade ?
                <li className="collection-item">
                  Grade: <span className="right-align"><b>{employee.grade}</b></span>
                </li>
                 : ''
              }
              { employee.subgrade ?
                <li className="collection-item">
                  Subgrade: <span className="right-align"><b>{employee.subgrade}</b></span>
                </li>
                 : ''
              }
              <li className="collection-item">
                Phone: <span className="right-align"><b>{ employee.phone ? employee.phone : employee.mobilePhone ? employee.mobilePhone : 'N/A'}</b></span>
              </li>
              <li className="collection-item">
                Email: <span className="right-align"><b><a href={`mailto:${employee.email}`}>{ employee.email }</a></b></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}


export default EmployeeInfoCard;


/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/view/employeeInfoCard.js